<script>
    import { fade } from "svelte/transition";
    import HeaderBar from "../../../components/header/HeaderBar.svelte";
    import { createEventDispatcher } from "svelte";

    export let slideTitle = "";
    export let slideOpen = false;

    export let slideColor = "var(--white-100)";

    let dispatch = createEventDispatcher();

    function onCollapse() {
        slideOpen = false;
        dispatch("collapse");
    }
</script>

<div class="divider-v divider" />

<div class="segment-container">
    <div class="first-segment">
        <slot name="firstSegment" />
        <div class="desktop-segment">
            <div class="divider-h" />
            <slot name="sliderContent" />
        </div>
    </div>
    <div class="second-segment">
        <slot name="secondSegment" />
    </div>

    {#if slideOpen}
        <div
            class="slider-segment"
            style="background-color: {slideColor};"
            in:fade={{ y: 812, duration: 400, opacity: 1 }}
            out:fade={!slideOpen
                ? { y: 812, duration: 400, opacity: 1 }
                : { y: 0, duration: 1, opacity: 1 }}
        >
            <HeaderBar
                on:actionClicked={onCollapse}
                title={slideTitle}
                close
                backgroundColor={slideColor}
            />
            <slot name="sliderContent" />
        </div>
    {/if}
</div>

<style>
    .first-segment {
        width: 100%;
        margin: 0 16px 8px 0px;
        max-width: 100%;
        height: auto;
    }

    .segment-container {
        display: flex;
        justify-content: start;
        flex-direction: column;
        margin-top: 16px;
        margin-bottom: 16px;
        padding: 0 16px;
        width: 100%;
        box-sizing: border-box;
    }

    .divider {
        display: none;
        position: fixed;
    }

    .slider-segment {
        position: fixed;
        background-color: var(--white-100);
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 100%;
        display: block;
        padding: 0 16px;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
    }

    .desktop-segment {
        display: none;
    }

    @media only screen and (min-width: 1440px) {
        .segment-container {
            display: flex;
            justify-content: start;
            flex-direction: row;
            margin-top: 48px;
            margin-bottom: 16px;
            height: calc(100% - 128px);
        }

        .first-segment {
            width: 33%;
            margin: 0 16px 8px 16px;
            max-width: 620px;
            height: 100%;
        }

        .divider {
            display: block;
            position: absolute;
            left: calc(33% + 24px);
            right: calc(76% - 25px);
            top: 48px;
            bottom: 48px;
            height: unset;
            z-index: 2;
        }

        .desktop-segment {
            display: block;
            padding-right: 32px;
        }

        .slider-segment {
            display: none;
        }

        .second-segment {
            padding-top: 84px;
            left: 35%;
            margin: 0px 8px 0px 8px;
            overflow: auto;
            position: absolute;
            padding-right: 16px;
            right: 0px;
            top: 0px;
            bottom: 0px;
            overflow-x: hidden;
        }
    }
</style>
